<template>
  <div class="page events">
    <btn-nav>
      <button @click="newEvent" class="btn">Add Event</button>
    </btn-nav>

    <div class="contain events">
      <div class="stats small">
        <div class="card">
          <p class="stat">
            {{ stats.orders }}
            <span>Orders</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            ${{ stats.revenue }}
            <span>Revenue</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            {{ stats.tickets_sold }}
            <span>Tickets Sold</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            {{ this.tickets.total - this.tickets.sold }}
            <span>Tickets Remaining</span>
          </p>
        </div>
      </div>
      <h1>Events</h1>
      <div class="filters">
        <input
          type="text"
          placeholder="Search by event name."
          class="search filter"
          v-model="query"
          @input="this.handleFilter"
        />
        <select
          id="date-filter"
          name="date-filter"
          class="date filter"
          v-model="selectedStatusOption"
          @change="onStatusFilterChange()"
        >
          <option
            v-for="(option, i) in status_filter_options"
            :key="i"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>

      <table class="events">
        <thead>
          <td>
            Event<img
              @click="sort('event_title')"
              class="filter_icon"
              :class="
                currentSort === 'event_title' && currentSortDir === 'desc'
                  ? 'down-arrow'
                  : null
              "
              src="@/assets/img/arrow.svg"
            />
          </td>
          <td>
            Start Date<img
              @click="sort('start_time')"
              class="filter_icon"
              :class="
                currentSort === 'start_time' && currentSortDir === 'desc'
                  ? 'down-arrow'
                  : null
              "
              src="@/assets/img/arrow.svg"
            />
          </td>
          <td>
            End Date<img
              @click="sort('end_time')"
              class="filter_icon"
              :class="
                currentSort === 'end_time' && currentSortDir === 'desc'
                  ? 'down-arrow'
                  : null
              "
              src="@/assets/img/arrow.svg"
            />
          </td>
          <td>
            Tickets Sold<img
              @click="sort('tickets_sold')"
              class="filter_icon"
              :class="
                currentSort === 'tickets_sold' && currentSortDir === 'desc'
                  ? 'down-arrow'
                  : null
              "
              src="@/assets/img/arrow.svg"
            />
          </td>
          <td>
            Gross<img
              @click="sort('gross_amount')"
              class="filter_icon"
              :class="
                currentSort === 'gross_amount' && currentSortDir === 'desc'
                  ? 'down-arrow'
                  : null
              "
              src="@/assets/img/arrow.svg"
            />
          </td>
          <td>
            Status<img
              @click="sort('status')"
              class="filter_icon"
              :class="
                currentSort === 'status' && currentSortDir === 'desc'
                  ? 'down-arrow'
                  : null
              "
              src="@/assets/img/arrow.svg"
            />
          </td>
        </thead>

        <tbody>
          <tr
            v-for="event in sortedEvents"
            @click="goTo('/event/' + event.id + '/management')"
            :key="event.id"
          >
            <td>{{ event.event_title }}</td>
            <td>{{ event.start_time | format_date_time }}</td>
            <td>{{ event.end_time | format_date_time }}</td>
            <td>{{ event.tickets_sold }}</td>
            <td>${{ event.gross_amount }}</td>
            <td>{{ event.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
  },
  data() {
    return {
      events: [],
      stats: {
        orders: 0,
        tickets_sold: 0,
        revenue: 0,
      },
      tickets: {
        total: 0,
        sold: 0,
      },
      status_filter_options: [
        { label: "All", value: 0 },
        { label: "Published", value: "PUBLISHED" },
        { label: "Draft", value: "DRAFT" },
        { label: "Past", value: "PAST" },
      ],
      query: "",
      filtered_orders: [],
      unfilteredEvents: [],
      selectedStatusOption: 0,
      currentSort: "start_time",
      currentSortDir: "asc",
    };
  },
  firestore() {
    return {
      orders: db
        .collection("user")
        .doc(this.$store.state.user.uid)
        .collection("orders"),
    };
  },
  mounted() {},
  created() {
    this.getAnalytics();
  },
  updated() {},
  computed: {
    sortedEvents: function () {
      return this.events.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        let firstEl =
          typeof a[this.currentSort] === "string"
            ? a[this.currentSort].toLowerCase()
            : a[this.currentSort];
        let secondEl =
          typeof b[this.currentSort] === "string"
            ? b[this.currentSort].toLowerCase()
            : b[this.currentSort];
        if (firstEl < b[this.currentSort]) return -1 * modifier;
        if (firstEl > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },
  methods: {
    newEvent() {
      this.$parent.$children[0].swipe = true;
      this.$parent.$parent.$children[0].swipe = true;
      return setTimeout(() => {
        this.$parent.$children[0].swipe = false;
        this.$parent.$parent.$children[0].swipe = false;
        let newID = db.collection("event").doc().id;
        this.$router.push({ path: `event/${newID}/content` });
      }, 800);
    },
    async getAnalytics() {
      return db
        .collectionGroup("event_analytics")
        .where("user_id", "==", this.$store.state.user.uid)
        .orderBy("start_time", "asc")
        .get()
        .then((query) => {
          let tickets_sold = 0;
          let revenue = 0;

          this.events = query.docs.map((d) => {
            let event = d.data();
            this.getTicketsSold(d.id);
            this.getTicketsTotal(d.id);
            revenue = revenue + event.gross_amount;
            tickets_sold = tickets_sold + event.tickets_sold;
            return Object.assign({ id: d.id }, event);
          });
          this.unfilteredEvents = this.events;
          this.stats.revenue = revenue;
          this.stats.orders = this.orders.length;
          this.stats.tickets_sold = tickets_sold;
        });
    },
    async getTicketsSold(event_id) {
      await db
        .collection("event")
        .doc(event_id)
        .collection("orders")
        .get()
        .then((snapshot) => {
          snapshot.docs.map((d) => {
            let order = d.data();
            this.tickets.sold += parseInt(order.ticket_num);
          });
        });
    },
    async getTicketsTotal(event_id) {
      await db
        .collection("event")
        .doc(event_id)
        .collection("ticket")
        .get()
        .then((snapshot) => {
          snapshot.docs.map((d) => {
            let ticket = d.data();
            this.tickets.total += parseInt(ticket.quantity);
          });
        });
    },
    handleFilter() {
      if (this.query) {
        let query = this.query.toLowerCase();
        let filtered_events = this.unfilteredEvents.filter((event) =>
          event.event_title.toLowerCase().includes(query)
        );
        this.events = filtered_events;
      } else {
        this.events = this.unfilteredEvents;
      }
    },
    onStatusFilterChange() {
      if (this.selectedStatusOption && this.events.length) {
        let filtered_events = this.events.filter((event) => {
          if (event.status === this.selectedStatusOption) {
            return event;
          }
        });
        return (this.events = filtered_events);
      } else {
        this.tickets = {
          total: 0,
          sold: 0,
        };
        return this.getAnalytics();
      }
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    .stat {
      font-size: 80px;
      color: #fba500;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
  &.small {
    justify-content: flex-start;
    .card {
      width: 170px !important;
      margin-right: 20px;
      padding-top: 30px;
      padding: 20px;
      .stat {
        font-size: 46px;
        span {
          font-size: 14px;
          margin-top: -5px;
        }
      }
    }
  }
}
.events {
  width: 100%;
  border-collapse: collapse;

  thead {
    background-color: #efefef;

    td {
      padding: 10px;
    }
  }

  tbody {
    td {
      padding: 20px 10px;
      border-bottom: 1px solid #eaeaea;
      background-color: transparent;
    }

    tr {
      background-color: white;
      transition: background-color 0.3s;
      cursor: pointer;

      &:hover {
        background-color: #f7f7f7;
      }
    }
  }
}
.filters {
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  margin-bottom: 10px;
}
.search {
  width: 33%;
}
#date-filter {
  background-color: white;
  border: none;
  outline: none;
  padding: 10px 15px;
  font-size: 17px;
  color: #0d0d0d;
  width: 25%;
  box-shadow: 0 0 8px rgba(128, 128, 128, 0.2);
  margin-left: 8px;
}
.filter_icon {
  height: 15px;
  margin-left: 10px;
  padding-top: 1px;
}
.filter_icon:hover {
  cursor: pointer;
}
.down-arrow {
  transform: rotateZ(180deg);
}
</style>
